// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const GlobeAltIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "GlobeAlt/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.083 9H6.03c.089-1.546.383-2.97.838-4.118A6.004 6.004 0 0 0 4.083 9ZM10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 2c-.076 0-.232.032-.465.262-.238.234-.497.623-.737 1.182-.389.907-.673 2.142-.766 3.556h3.936c-.093-1.414-.377-2.649-.766-3.556-.24-.56-.5-.948-.737-1.182C10.232 4.032 10.076 4 10 4Zm3.972 5c-.09-1.546-.384-2.97-.838-4.118A6.004 6.004 0 0 1 15.917 9h-1.945Zm-2.004 2H8.032c.093 1.414.377 2.649.766 3.556.24.56.5.948.737 1.182.233.23.39.262.465.262.076 0 .232-.032.465-.262.238-.234.498-.623.737-1.182.389-.907.673-2.142.766-3.556Zm1.166 4.118c.454-1.147.748-2.572.838-4.118h1.945a6.004 6.004 0 0 1-2.783 4.118Zm-6.267 0c-.455-1.147-.749-2.572-.838-4.118H4.083a6.004 6.004 0 0 0 2.784 4.118Z",
  clipRule: "evenodd"
}));
export default GlobeAltIcon;